var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-layout-sider",
    {
      class: ["side-menu", "beauty-scroll", _vm.isMobile ? null : "shadow"],
      attrs: {
        theme: _vm.sideTheme,
        width: "256px",
        collapsible: _vm.collapsible,
        trigger: null,
      },
      model: {
        value: _vm.collapsed,
        callback: function ($$v) {
          _vm.collapsed = $$v
        },
        expression: "collapsed",
      },
    },
    [
      _c("div", { staticClass: "user_left_box" }, [
        _c("img", {
          staticStyle: {
            width: "150px",
            "margin-left": "-15px",
            "margin-top": "-5px",
          },
          attrs: { src: require("@/assets/img/logo.png"), alt: "" },
        }),
      ]),
      _c("i-menu", {
        staticClass: "menu beauty-scroll",
        attrs: {
          theme: _vm.theme,
          collapsed: _vm.collapsed,
          options: _vm.menuData,
        },
        on: { select: _vm.onSelect },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }